import WebViewCommunicatorResource, {
  WebviewBridgeCommands,
} from '../../services/resources/WebViewCommunicatorResource';

export default function useSound() {
  return {
    playSound: (type = WebviewBridgeCommands.PlaySound) => {
      WebViewCommunicatorResource.playSound(type);
    },
  };
}
